// Create an AuthLayout component based on the Catalyst UI pattern
const AuthLayout = ({ children }) => {
    return (
      <main className="flex h-full overflow-y-auto flex-col p-2">
        <div className="flex grow items-center justify-center p-6 lg:rounded-lg lg:bg-white lg:p-10 dark:lg:bg-brand-dark-900">
          {children}
        </div>
      </main>
    );
  };

export default AuthLayout;